const ToasterDanger = () => {
  return (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="21.5"
        cy="21.5"
        r="19.4024"
        stroke="white"
        strokeWidth="4.19512"
      />
      <path
        d="M14 29.1484L29 13.9998"
        stroke="#FDFDFD"
        strokeWidth="4.19512"
      />
      <path
        d="M29 29.1484L14 13.9998"
        stroke="#FDFDFD"
        strokeWidth="4.19512"
      />
    </svg>
  );
};

export default ToasterDanger;
